import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import AccardionLike from '../../../../../module/newShop/advertisementRegisteration/accadionlikeAR';
import useGetAdCatalog from '../../../../../services/hookService/getAdCatalog/useGetAdCatalog';
import {RootState} from '../../../../../store/redux';
import {clearAllData} from '../../../../../store/redux/addPictureAdvertisment';
import {
  addFormData,
  addOptionalFormData,
  addRegisterAdvertisement,
} from '../../../../../store/redux/advertisementRegisteration';
import {CodeToInputGroupName} from '../../../myFavouriteAdd/card/helper';
import {groupTitle} from '../../constants';
import {ISaleBuyRentService} from '../../types';
import ProvideServiceMachineryForm from './provideServiceMachineryForm';
import ProvidedServiceEmployeeForm from './providedServiceEmployeeForm';
import WantedServiceEmployeeForm from './wantedServiceEmployeeForm';
import WantedServiceLabForm from './wantedServiceLabForm';
import WantedServiceMachineryForm from './wantedServiceMachineryForm';
import {
  AdvertisementType,
  InputGroupCode,
} from '../../../../../utilities/helper/unitGenerator/unit.types';
import {getRestrictedInputGroups} from '../../../../../global/helpers/getRestrictedInputGroups';
function Service({
  storePlanType,
  srs_type,
  isLoading,
  setOpenInputListBottomSheet,
  setModalText,
  guid,
  unitData,
}: ISaleBuyRentService) {
  const dispatch = useDispatch();

  const {input, input_group, serviceBottomSheetData, ad_type} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );
  const isPersonalAd = ad_type.value === 'personal';
  const {addCatalogData} = useGetAdCatalog({parent: guid});
  const restrictedInputGroups = getRestrictedInputGroups({
    adType: ad_type.value,
    storePlanType: storePlanType!,
    advertisementType: AdvertisementType.PROVIDED_SERVICE,
  });
  const handleAccordionLike = (
    item: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    dispatch(
      addRegisterAdvertisement({
        input_group: {
          guid: item.guid,
          code: item.code,
          type: CodeToInputGroupName[item.code],
        },
      }),
    );
    dispatch(
      addRegisterAdvertisement({
        input: undefined,
        sub_input: undefined,
      }),
    );
    dispatch(clearAllData());
    dispatch(addFormData(''));
  };
  useEffect(() => {
    if (ad_type?.value === 'store') {
      dispatch(
        addRegisterAdvertisement({
          serviceBottomSheetData: 'providedService',
        }),
      );
    }
  }, [ad_type?.value]);

  return (
    <div>
      {serviceBottomSheetData && (
        <>
          <section className="mb-3">
            <p className="mt-3 text-md">
              {groupTitle[srs_type.type + serviceBottomSheetData]}
            </p>
            {addCatalogData
              ?.find(item => {
                if (serviceBottomSheetData === 'providedService') {
                  return item.kind === 'give';
                } else {
                  return item.kind === 'catch';
                }
              })
              ?.input_Group_object.map((item, index) => {
                return (
                  <AccardionLike
                    key={item.guid ?? item.code ?? index}
                    logo={item.image}
                    title={item.title}
                    disable={
                      isPersonalAd
                        ? false
                        : !restrictedInputGroups.includes(item.code)
                    }
                    active={input_group?.guid === item?.guid}
                    activeInput={
                      input_group?.guid === item?.guid ? input : undefined
                    }
                    onClick={() => {
                      handleAccordionLike(item);
                      setOpenInputListBottomSheet(true);
                      dispatch(addOptionalFormData(''));
                      dispatch(addFormData(''));
                      dispatch(addRegisterAdvertisement({}));
                    }}
                    onRemoveItem={() => {
                      dispatch(
                        addRegisterAdvertisement({
                          input: undefined,
                          sub_input: undefined,
                        }),
                      );
                      dispatch(clearAllData());
                      dispatch(addFormData(''));
                    }}
                  />
                );
              })}
          </section>

          {input?.title && (
            <>
              {serviceBottomSheetData === 'providedService' &&
                input_group?.code === InputGroupCode.MACHINERY && (
                  <ProvideServiceMachineryForm isLoading={isLoading} />
                )}
              {serviceBottomSheetData === 'wantedService' &&
                input_group?.code === InputGroupCode.MACHINERY && (
                  <WantedServiceMachineryForm
                    setModalText={setModalText}
                    isLoading={isLoading}
                  />
                )}
              {serviceBottomSheetData === 'providedService' &&
                input_group?.code === InputGroupCode.EMPLOYEE && (
                  <ProvidedServiceEmployeeForm isLoading={isLoading} />
                )}
              {serviceBottomSheetData === 'wantedService' &&
                input_group?.code === InputGroupCode.EMPLOYEE && (
                  <WantedServiceEmployeeForm
                    setModalText={setModalText}
                    isLoading={isLoading}
                  />
                )}
              {serviceBottomSheetData === 'wantedService' &&
                input_group?.code === InputGroupCode.LAB && (
                  <WantedServiceLabForm
                    setModalText={setModalText}
                    isLoading={isLoading}
                  />
                )}
            </>
          )}
        </>
      )}
    </div>
  );
}

export default React.memo(Service);
